module.exports = __webpack_public_path__ + "69cc9f4d175d74cf75cbe5d21ceafd61.svg";